import { FC } from "react";
import { ModalDialog } from "@rothoblaas/design-system";
import useI18n from "../../hooks/useTranslations";
import { AdminItemSummary, NewEditAdminItem } from "./AdminItem";

interface AdminItemModalProps {
  onClose: () => void;
  onCreateSuccess: (item: AdminItemSummary) => void;
}

const AdminItemModal: FC<AdminItemModalProps> = ({ onClose, onCreateSuccess }) => {
  const i18n = useI18n();

  return (
    <ModalDialog onClose={onClose} title={i18n.translation.items.createNew}>
      <NewEditAdminItem disableNavigationOnSuccess onCreateSuccess={onCreateSuccess} onClose={onClose} />
    </ModalDialog>
  );
};

export default AdminItemModal;
